import { render } from "./WhyChoose.vue?vue&type=template&id=37f22c2c"
import script from "./WhyChoose.vue?vue&type=script&lang=js"
export * from "./WhyChoose.vue?vue&type=script&lang=js"

import "./WhyChoose.vue?vue&type=style&index=0&id=37f22c2c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__